import React from 'react'

import ManageBatchMixing from 'components/premix/manageBatchMixing'

interface IMixingInventoryListProps {
  isComplete?: boolean
  department?: string
}

export default function MixingInventoryList({
  isComplete,
  department,
}: IMixingInventoryListProps) {
  return (
    <ManageBatchMixing
      isIncompleteOnly={!isComplete}
      isCompleteOnly={isComplete}
      isMixing
      onlyProduction
      excludeVirtual={true}
      department={department}
    />
  )
}
